import {
    Component, SimpleChanges, AfterViewInit, Input,
    ViewEncapsulation, HostBinding
} from '@angular/core';

export type Mode = 'horizontal' | 'vertical' | 'inline';
export const PADDING_BASE = 24;

@Component({
    selector: '[jui-menu]',
    template: `
        <ng-content></ng-content>
    `,
    styles: [`
      @font-face {
        font-family: 'iconfont';
        /* project id 290315 */
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

      .iconfont {
        display: inline-block;
        vertical-align: baseline;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; }

      .icon-jui-alert:before {
        content: "\\e600"; }

      .icon-jui-search:before {
        content: "\\e630"; }

      .icon-jui-paper3:before {
        content: "\\e652"; }

      .icon-jui-setting:before {
        content: "\\e602"; }

      .icon-jui-left2:before {
        content: "\\e697"; }

      .icon-jui-wrong:before {
        content: "\\e69a"; }

      .icon-jui-up2:before {
        content: "\\e6a5"; }

      .icon-jui-down2:before {
        content: "\\e6a6"; }

      .icon-jui-right2:before {
        content: "\\e6a7"; }

      .icon-jui-correct2:before {
        content: "\\e627"; }

      .icon-jui-qq:before {
        content: "\\e63a"; }

      .icon-jui-email:before {
        content: "\\e62a"; }

      .icon-jui-edit:before {
        content: "\\e686"; }

      .icon-jui-download2:before {
        content: "\\e714"; }

      .icon-jui-speaker:before {
        content: "\\e85c"; }

      .icon-jui-add:before {
        content: "\\e609"; }

      .icon-jui-msg:before {
        content: "\\e613"; }

      .icon-jui-minus:before {
        content: "\\e601"; }

      .icon-jui-up:before {
        content: "\\e658"; }

      .icon-jui-letter-open:before {
        content: "\\e61d"; }

      .icon-jui-down:before {
        content: "\\ed22"; }

      .icon-jui-info:before {
        content: "\\e685"; }

      .icon-jui-cross2:before {
        content: "\\e6b4"; }

      .icon-jui-paper2:before {
        content: "\\e71e"; }

      .icon-jui-loading:before {
        content: "\\eee3"; }

      .icon-jui-road-sign:before {
        content: "\\e604"; }

      .icon-jui-left:before {
        content: "\\e66a"; }

      .icon-jui-letter:before {
        content: "\\e605"; }

      .icon-jui-right:before {
        content: "\\e64d"; }

      .icon-jui-back-top:before {
        content: "\\e628"; }

      .icon-jui-dropdown:before {
        content: "\\e75a"; }

      .icon-jui-down3:before {
        content: "\\e629"; }

      .icon-jui-alarm:before {
        content: "\\e6c2"; }

      .icon-jui-paper:before {
        content: "\\e612"; }

      .icon-jui-cross:before {
        content: "\\e6b0"; }

      .icon-jui-correct:before {
        content: "\\e6b3"; }

      .icon-jui-up3:before {
        content: "\\eee4"; }

      .icon-jui-username:before {
        content: "\\e670"; }

      .icon-jui-password:before {
        content: "\\e615"; }

      .icon-jui-slideLeft:before {
        content: "\\e603"; }

      .icon-jui-slideRight:before {
        content: "\\e641"; }

      /* icon Animate */
      .icon-doTurn {
        -webkit-animation: doTurn 1s infinite linear;
        animation: doTurn 1s infinite linear; }

      @-webkit-keyframes doTurn {
        0% {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(0deg); }
        to {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(1turn); } }

      @keyframes doTurn {
        0% {
          transform-origin: 50% 50%;
          transform: rotate(0deg); }
        to {
          transform-origin: 50% 50%;
          transform: rotate(1turn); } }
      @charset "UTF-8";
      .jui-menu {
        font-size: 14px;
        z-index: 1050;
        line-height: 46px;
        list-style: none;
        outline: none;
        color: rgba(0, 0, 0, 0.65);
        background: #fff;
        transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
        /* 禁用 */
        /* 选项 */
        /* 组合选项 */
        /* 子菜单 */
        /* 水平 */
        /* 垂直 */
        /* 内嵌 */ }
        .jui-menu:after {
          content: " ";
          display: block;
          height: 0;
          clear: both; }
        .jui-menu a {
          display: block;
          color: rgba(0, 0, 0, 0.65); }
          .jui-menu a:hover {
            color: #108ee9;
            text-decoration: none; }
        .jui-menu .jui-menu-item-disabled, .jui-menu .jui-menu-submenu-disabled {
          color: rgba(0, 0, 0, 0.25) !important;
          cursor: not-allowed !important;
          background: none;
          border-color: transparent !important; }
          .jui-menu .jui-menu-item-disabled a, .jui-menu .jui-menu-submenu-disabled a {
            pointer-events: none;
            color: rgba(0, 0, 0, 0.25) !important;
            cursor: not-allowed !important; }
          .jui-menu .jui-menu-item-disabled .jui-menu-submenu-title, .jui-menu .jui-menu-submenu-disabled .jui-menu-submenu-title {
            cursor: not-allowed !important; }
        .jui-menu .jui-menu-item, .jui-menu .jui-menu-submenu-title {
          margin: 0;
          padding: 0 20px;
          position: relative;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1); }
          .jui-menu .jui-menu-item .iconfont, .jui-menu .jui-menu-submenu-title .iconfont {
            min-width: 14px;
            margin-right: 8px;
            transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); }
          .jui-menu .jui-menu-item .iconfont + span, .jui-menu .jui-menu-submenu-title .iconfont + span {
            transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            opacity: 1; }
        .jui-menu .jui-menu-item-group .jui-menu-item-group-title {
          color: rgba(0, 0, 0, 0.43);
          line-height: 1.5;
          padding: 8px 16px;
          cursor: auto; }
        .jui-menu .jui-menu-item-group .jui-menu-item-group-list {
          margin: 0;
          padding: 0; }
          .jui-menu .jui-menu-item-group .jui-menu-item-group-list .jui-menu-item, .jui-menu .jui-menu-item-group .jui-menu-item-group-list .jui-menu-submenu-title {
            padding: 0 16px 0 28px; }
        .jui-menu .jui-menu-submenu {
          position: relative;
          cursor: pointer; }
          .jui-menu .jui-menu-submenu .jui-menu-submenu-title .icon-more {
            position: absolute;
            top: 50%;
            margin-top: -5px;
            right: 6px;
            font-size: 12px;
            transform: rotate(0);
            -webkit-transform: rotate(0);
            transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); }
            .jui-menu .jui-menu-submenu .jui-menu-submenu-title .icon-more.active {
              transform: rotate(180deg) !important;
              -webkit-transform: rotate(180deg) !important; }
        .jui-menu.jui-menu-horizontal {
          border-bottom: 1px solid #e9e9e9; }
          .jui-menu.jui-menu-horizontal > .jui-menu-item, .jui-menu.jui-menu-horizontal > .jui-menu-submenu {
            position: relative;
            float: left;
            border-bottom: 2px solid transparent; }
          .jui-menu.jui-menu-horizontal .jui-menu-submenu-horizontal > .jui-menu-submenu-title .icon-more {
            right: -6px; }
          .jui-menu.jui-menu-horizontal .jui-menu-submenu-horizontal > .jui-menu-submenu-sub {
            border-radius: 4px;
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
            font-size: 12px;
            top: 100%;
            left: 0;
            position: absolute;
            min-width: 100%;
            margin-top: 7px; }
          .jui-menu.jui-menu-horizontal > .jui-menu-item:hover,
          .jui-menu.jui-menu-horizontal > .jui-menu-submenu:hover,
          .jui-menu.jui-menu-horizontal > .jui-menu-item-selected,
          .jui-menu.jui-menu-horizontal > .jui-menu-submenu-selected {
            border-bottom: 2px solid #108ee9;
            color: #108ee9; }
        .jui-menu.jui-menu-vertical {
          border-right: 1px solid #e9e9e9; }
          .jui-menu.jui-menu-vertical .jui-menu-submenu-vertical > .jui-menu-item, .jui-menu.jui-menu-vertical .jui-menu-submenu-vertical > .jui-menu-submenu-title {
            padding: 0 16px;
            line-height: 42px;
            height: 42px;
            overflow: hidden;
            text-overflow: ellipsis; }
          .jui-menu.jui-menu-vertical .jui-menu-submenu-vertical > .jui-menu-submenu-sub {
            border-radius: 4px;
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
            font-size: 12px;
            top: 0;
            left: 100%;
            position: absolute;
            min-width: 160px;
            margin-left: 4px; }
        .jui-menu.jui-menu-inline {
          border-right: 1px solid #e9e9e9; }
          .jui-menu.jui-menu-inline .jui-menu-submenu-inline > .jui-menu-item, .jui-menu.jui-menu-inline .jui-menu-submenu-inline > .jui-menu-submenu-title {
            padding: 0 16px;
            line-height: 42px;
            height: 42px;
            overflow: hidden;
            text-overflow: ellipsis; }
          .jui-menu.jui-menu-inline .jui-menu-submenu-inline > .jui-menu-submenu-sub {
            border: 0;
            font-size: 12px; }
          .jui-menu.jui-menu-inline .jui-menu-submenu-inline .jui-menu-item-group .jui-menu-item-group-title {
            padding-left: 32px; }
          .jui-menu.jui-menu-inline .jui-menu-item-selected {
            background-color: #ecf6fd;
            border-right: 3px solid #108ee9;
            color: #108ee9; }
        .jui-menu .jui-menu-item:hover,
        .jui-menu .jui-menu-submenu-title:hover,
        .jui-menu .jui-menu-item-selected,
        .jui-menu .jui-menu-submenu-selected {
          color: #108ee9; }

      /* 黑色主题 */
      .jui-menu-root.jui-menu-dark {
        color: rgba(255, 255, 255, 0.5);
        background: #404040; }
        .jui-menu-root.jui-menu-dark a {
          color: rgba(255, 255, 255, 0.5); }
        .jui-menu-root.jui-menu-dark.jui-menu-inline, .jui-menu-root.jui-menu-dark.jui-menu-vertical, .jui-menu-root.jui-menu-dark .jui-menu-inline, .jui-menu-root.jui-menu-dark .jui-menu-vertical {
          border-right: 0; }
        .jui-menu-root.jui-menu-dark .jui-menu-item-disabled, .jui-menu-root.jui-menu-dark .jui-menu-submenu-disabled {
          color: #6d6d6d !important; }
        .jui-menu-root.jui-menu-dark .jui-menu-item-group .jui-menu-item-group-title {
          color: rgba(255, 255, 255, 0.5); }
        .jui-menu-root.jui-menu-dark .jui-menu-submenu-sub {
          color: rgba(255, 255, 255, 0.5);
          background: #333; }
        .jui-menu-root.jui-menu-dark .jui-menu-item-selected {
          border: 0;
          background-color: #108ee9;
          color: #fff; }
        .jui-menu-root.jui-menu-dark .jui-menu-item:hover,
        .jui-menu-root.jui-menu-dark .jui-menu-submenu:hover,
        .jui-menu-root.jui-menu-dark .jui-menu-submenu-title:hover,
        .jui-menu-root.jui-menu-dark .jui-menu-submenu-selected,
        .jui-menu-root.jui-menu-dark .jui-menu-submenu-selected > .jui-menu-submenu-title i {
          color: #fff; }

      /* 收缩模式 */
      .jui-menu-root.jui-menu-collapsed {
        width: 64px; }
        .jui-menu-root.jui-menu-collapsed > .jui-menu-item,
        .jui-menu-root.jui-menu-collapsed > .jui-menu-submenu > .jui-menu-submenu-title {
          left: 0;
          text-overflow: clip;
          padding: 0 24px; }
          .jui-menu-root.jui-menu-collapsed > .jui-menu-item .iconfont,
          .jui-menu-root.jui-menu-collapsed > .jui-menu-submenu > .jui-menu-submenu-title .iconfont {
            font-size: 16px;
            line-height: 42px;
            margin: 0; }
          .jui-menu-root.jui-menu-collapsed > .jui-menu-item .iconfont + span,
          .jui-menu-root.jui-menu-collapsed > .jui-menu-submenu > .jui-menu-submenu-title .iconfont + span {
            max-width: 0;
            display: inline-block;
            opacity: 0; }
          .jui-menu-root.jui-menu-collapsed > .jui-menu-item .icon-more,
          .jui-menu-root.jui-menu-collapsed > .jui-menu-submenu > .jui-menu-submenu-title .icon-more {
            display: none; }
    `],
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements AfterViewInit {
    hostEl: HTMLElement;
    hasSubMenu = false;
    subMenus: any[] = [];
    menuItems: any[] = [];
    subMenusOpenIndex: any[] = [];
    _collapsed = false;
    isViewInit = false;
    tempMode: Mode;

    // 模式（水平、垂直、内嵌）
    @Input() mode: Mode = 'horizontal';
    // 主题
    @Input() theme: 'light' | 'dark' = 'light';
    // 是否收缩（垂直、内嵌模式有效）
    @Input()
    get collapsed(): boolean {
        return this._collapsed;
    }
    set collapsed(value: boolean) {
        this._collapsed = value;
        if (!this.isViewInit) {
            return;
        }
        this.collapsedChange();
    }

    @HostBinding('class.jui-menu')
    @HostBinding('class.jui-menu-root')
    get setRootMenuClass() {
        return true;
    }
    @HostBinding('class.jui-menu-horizontal')
    get setMenuHorizontalClass() {
        return (this.mode === 'horizontal');
    }
    @HostBinding('class.jui-menu-vertical')
    get setMenuVerticalClass() {
        return (this.mode === 'vertical');
    }
    @HostBinding('class.jui-menu-inline')
    get setMenuInlineClass() {
        return (this.mode === 'inline');
    }
    @HostBinding('class.jui-menu-light')
    get setMenuThemeLightClass() {
        return this.theme === 'light';
    }
    @HostBinding('class.jui-menu-dark')
    get setMenuThemeDarkClass() {
        return this.theme === 'dark';
    }
    @HostBinding('class.jui-menu-collapsed')
    get setMenuCollapsedClass() {
        return (this.collapsed) && (this.mode !== 'horizontal');
    }

    constructor() { }

    ngAfterViewInit() {
        this.isViewInit = true;
        this.tempMode = this.mode;
        // 当默认就是收缩模式时，执行一次
        this.collapsedChange();
    }

    setHasSubMenu(value: boolean) {
        setTimeout(() => {
            this.hasSubMenu = value;
        }, 0);
    }
    clearAllSelected() {
        this.menuItems.forEach(menu => menu.selected = false);
    }

    hideSubMenus() {
        this.subMenusOpenIndex = [];
        this.subMenus.forEach((submenu, index) => {
            if (submenu.isOpen) {
                this.subMenusOpenIndex.push(index);
            }
            submenu.isOpen = false;
        });
    }
    showSubMenus() {
        this.subMenusOpenIndex.forEach((i) => {
            this.subMenus[i].isOpen = true;
        });
        this.subMenusOpenIndex = [];
    }

    private collapsedChange() {
        if (this._collapsed) {
            this.hideSubMenus();
            // after the animation is over
            setTimeout(() => this.mode = 'vertical', 150);
        } else {
            this.showSubMenus();
            this.mode = this.tempMode;
        }
    }
}
